var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C7.5817 2 4 5.5817 4 10C4 14.9029 6.7701 19.385 11.1554 21.5777L12 22L12.8446 21.5777C17.2299 19.385 20 14.9029 20 10C20 5.5817 16.4183 2 12 2ZM12 6C13.1046 6 14 6.8954 14 8C14 9.1046 13.1046 10 12 10C10.8954 10 10 9.1046 10 8C10 6.8954 10.8954 6 12 6ZM14.4156 14H9.5843C9.2597 14 8.9974 13.6887 9.0979 13.3801C9.3588 12.579 10.1118 12 10.9999 12H12.9999C13.8881 12 14.641 12.5789 14.9019 13.3801C15.0024 13.6887 14.7402 14 14.4156 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.222e5d4fe7882632b4147313c5a4b025.svg";
export { ForwardRef as ReactComponent };